import { ErrorAction, StateUtils } from '@spartacus/core';
import { LoaderError } from '../../../model';

declare module '@spartacus/core/src/state/utils/loader' {
  interface LoaderMeta {
    errorDetails?: LoaderError;
  }
}

export function failMeta(entityType: string, error?: any): StateUtils.LoaderMeta {
  return {
    entityType: entityType,
    loader: {
      error: error ? error : true,
    },
    errorDetails: error ? error : true,
  };
}

export class LoaderFailAction implements StateUtils.LoaderAction, ErrorAction {
  type = StateUtils.LOADER_FAIL_ACTION;
  public error: any;
  readonly meta: StateUtils.LoaderMeta;

  constructor(entityType: string, error?: any) {
    this.meta = failMeta(entityType, error);
    this.error = error;
  }
}
